<ng-container *ngIf="showMarketValueOverTime === false; else marketValueOverTime">
    <sb-performance-chart
        [series]="dataSeries"
        [context]="context.widgetId"
    ></sb-performance-chart>
</ng-container>

<ng-template #marketValueOverTime>
    <sb-market-value-over-time-chart></sb-market-value-over-time-chart>
</ng-template>
